import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77826430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8 d-flex" }
const _hoisted_5 = { class: "card mb-25 border-0 rounded-0 bg-white flex-grow-1" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_7 = { class: "col-lg-4 d-flex" }
const _hoisted_8 = { class: "card mb-25 border-0 rounded-0 bg-white flex-grow-1" }
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fs-20 text-uppercase fw-bold text-dark-emphasis" }, " Control Series Visibility ", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_SuggestedSystemPieChart = _resolveComponent("SuggestedSystemPieChart")!
  const _component_SeriesVisibilityControl = _resolveComponent("SeriesVisibilityControl")!
  const _component_SuggestedSystemTable = _resolveComponent("SuggestedSystemTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Suggested System Analysis" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_SuggestedSystemPieChart, {
                  tableName: _ctx.tableName,
                  hiddenSeries: _ctx.hiddenSeries
                }, null, 8, ["tableName", "hiddenSeries"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_SeriesVisibilityControl, {
                  labels: _ctx.chartLabels,
                  hiddenSeries: _ctx.hiddenSeries,
                  onToggleVisibility: _ctx.toggleVisibility
                }, null, 8, ["labels", "hiddenSeries", "onToggleVisibility"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_SuggestedSystemTable, {
              tableName: _ctx.tableName,
              hiddenSeries: _ctx.hiddenSeries
            }, null, 8, ["tableName", "hiddenSeries"])
          ])
        ])
      ])
    ])
  ], 64))
}